const HUMAN_SEAT = "P1";

const isBotSeat = (seat) => seat !== HUMAN_SEAT && seat !== "" && seat != null;

// Fast, non-simulated trump pick used once bidding has already decided a
// bot should win the bid: the suit it holds the most (and highest) cards
// in. Kept independent of the Monte Carlo bid evaluator so TrumpOptions
// (which only ever receives the winning hand, not bidding context) can pick
// a trump suit on its own without re-running simulations.
const pickBestTrumpHeuristic = (hand) => {
  const bySuit = {};
  for (const card of hand) {
    (bySuit[card.suit] ||= []).push(card);
  }
  let best = null;
  let bestScore = -Infinity;
  for (const suit of Object.keys(bySuit)) {
    const cards = bySuit[suit];
    const score = cards.length * 100 + cards.reduce((sum, c) => sum + c.details.value, 0);
    if (score > bestScore) {
      bestScore = score;
      best = suit;
    }
  }
  return best;
};

export { HUMAN_SEAT, isBotSeat, pickBestTrumpHeuristic };
